export const StatusCodes = ['Active', 'Inactive'] as const;
export type StatusCode = (typeof StatusCodes)[number];
